module.exports = __webpack_public_path__ + "static/media/MEX.f03a592f.png";